import React from 'react'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {listTimes} from '../../../utils/utils.jsx'
import {FormControlLabel, Radio} from '@mui/material'

import {textBodyColor} from '../../../metrics.module.scss'

import './scheduledTimes.scss'

const ScheduledTimes = ({onClick}) => {
    const weekDeliveryStore = getLocal('weekDeliveryStore', [])
    const weekShopStore = getLocal('weekShopStore', [])
    const deliveryMode = getLocal('deliveryMode', '')
    const times = listTimes((deliveryMode === 'delivery') ? weekDeliveryStore : weekShopStore)
    const handleClick = (value) => onClick(value)
    return <div className={'scheduled-times'}>
        {times.map(time =>
            <FormControlLabel
                key={time}
                sx={{'& .MuiTypography-root': {fontFamily: 'Nunito', color: textBodyColor}}}
                control={<Radio style={{color: textBodyColor, fontFamily: 'Nunito'}}/>}
                label={time.slice(0, -3)}
                onClick={() => handleClick(time)}/>
        )}
    </div>
}

export default ScheduledTimes
